var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardExpiryDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.426 27.077H64a4.5 4.5 0 014.5 4.5v33.907a4.5 4.5 0 01-4.5 4.5H28a4.5 4.5 0 01-4.5-4.5V31.577a4.5 4.5 0 014.5-4.5h3.542m17.974 25.548a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM45.72 62.751a3.376 3.376 0 010-6.751h.844a3.376 3.376 0 010 6.751h-.844zm-5.344-35.674h11.25m-12.208 7.81a3.376 3.376 0 11-6.751-.001 3.376 3.376 0 016.751.001zm19.884 0a3.376 3.376 0 01-6.75 0 3.374 3.374 0 116.75 0zm-35.8 8.097h45m-32.459-8.097v-10.95m19.884 10.95v-10.95",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.778 17.116c-.032.025-.082-.037-.107-.068-.128-4.734.087-9.49.722-14.172.006-.057.037-.082.068-.107 1.76-.242 3.415-.295 5.078-.149.312.004.539.284.534.597l-.673 8.575c-.006.056.019.087.075.093 2.45.229 5.938.596 8.389.825.056.006.081.037.075.093l-.719 5.214c-.006.056-.037.082-.093.076-.506-.053-9.807-.86-13.35-.977z",
    fill: "#FF94CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.365 72.948c.03-.017.064.043.081.073-.517 4.043-1.327 8.055-2.484 11.95-.011.048-.04.065-.071.082a19.23 19.23 0 01-4.326-.57c-.265-.046-.42-.314-.376-.58l1.704-7.2c.013-.046-.005-.077-.051-.09-2.048-.529-4.96-1.318-7.007-1.85-.047-.011-.065-.042-.052-.089l1.298-4.334c.012-.047.042-.065.09-.052.422.114 8.205 2.074 11.194 2.659z",
    fill: "#006AFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.396,
    cy: 43.396,
    r: 4,
    fill: "#006AFF",
    transform: "rotate(-174 81.396 43.396)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 60,
    r: 3,
    fill: "#FF94CA",
    fillRule: "nonzero",
    transform: "rotate(-180 4 60)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardExpiryDate);
export default __webpack_public_path__ + "static/media/card-expiry-date.c7463ae0.svg";
export { ForwardRef as ReactComponent };